<tds-side-menu aria-label="Side menu" persistent [open]="mobileNavOpen()" [collapsed]="isSideMenuCollapsed()">
  <tds-side-menu-overlay (click)="toggleMobileSideMenu()" slot="overlay"></tds-side-menu-overlay>

  <tds-side-menu-close-button slot="close-button" (click)="toggleMobileSideMenu()"></tds-side-menu-close-button>
  <div class="tds-u-pl2" style="text-align: left;">
    @if(!isSideMenuCollapsed()){
      <img src="assets/login-logo.png" width="109px" alt="R&D ASIA Logo" class="side-nav-logo" />
    }@else{
      <span class="top-sub-title">R&D</span>
    }
    
  </div>

  @for(navItem of navItems(); track navItem.label) {
    @if(navItem.children && !isSideMenuCollapsed()){
      <!-- Expanded mode: dropdown with children -->
      <tds-side-menu-dropdown *appHasRole="navItem.roles" id="wheel-types-dropdown" [selected]="isActiveChild(navItem)" default-open selected>
        @if (navItem.icon) {
          <tds-icon slot="icon" [name]="navItem.icon" size="24px"></tds-icon>
        }
        <span slot="label">{{ navItem.label | translate }}</span>
        <tds-side-menu-dropdown-list>
          @for(childItem of navItem.children; track childItem.label) {
            <tds-side-menu-dropdown-list-item [selected]="isActive(childItem.route)" *appHasRole="childItem.roles">
              <button [routerLink]="childItem.route" (click)="isMobileOrTablet() && toggleMobileSideMenu()">
                @if (getCustomSvg(childItem); as svgPath) {
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path [attr.d]="svgPath" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                } @else if (childItem.icon) {
                  <tds-icon [name]="childItem.icon" size="24"></tds-icon>
                }
                {{ childItem.label | translate }}
              </button>
            </tds-side-menu-dropdown-list-item>
          }
        </tds-side-menu-dropdown-list>
      </tds-side-menu-dropdown>
    } @else if (navItem.children && isSideMenuCollapsed()) {
      <!-- Collapsed mode: flatten children as icon-only items with tooltips -->
      @for(childItem of navItem.children; track childItem.label) {
        <tds-side-menu-item class="collapsed-child-item" *appHasRole="childItem.roles" [selected]="isActive(childItem.route)">
          <button [id]="getNavItemChildId(childItem)" [routerLink]="childItem.route" (click)="isMobileOrTablet() && toggleMobileSideMenu()">
            @if (getCustomSvg(childItem); as svgPath) {
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path [attr.d]="svgPath" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            } @else if (childItem.icon) {
              <tds-icon [name]="childItem.icon" size="24"></tds-icon>
            }
          </button>
        </tds-side-menu-item>
        <tds-tooltip
          placement="right"
          [text]="childItem.label | translate"
          [selector]="'#' + getNavItemChildId(childItem)"
          trigger="hover"
        ></tds-tooltip>
      }
    } @else {
      <tds-side-menu-item *appHasRole="navItem.roles" [selected]="isActive(navItem.route)">
        <button [routerLink]="navItem.route" (click)="isMobileOrTablet() && toggleMobileSideMenu()">
          @if(navItem.icon) {
            <tds-icon [name]="navItem.icon" size="24"></tds-icon>
          }
          {{ navItem.label | translate }}
        </button>
      </tds-side-menu-item>
    }
  }

  @if(isMobileOrTablet()) {
    <!-- role switcher for mobile -->
    @if(hasMultipleRoles()) {
      <tds-side-menu-dropdown slot="sticky-end" id="role-switch-dropdown">
        <span slot="label">{{ getCurrentRole() | roleTranslate }}</span>
        <tds-side-menu-dropdown-list>
          @for(role of availableRoles(); track role) {
          <tds-side-menu-dropdown-list-item [class.selected]="getCurrentRole() === role">
            <button (click)="onRoleChange(role); toggleMobileSideMenu()">
              <div class="role-item">
                <span class="role-name">{{ role | roleTranslate }}</span>
                @if(getCurrentRole() === role) {
                  <span class="role-indicator">✓</span>
                }
              </div>
            </button>
          </tds-side-menu-dropdown-list-item>
          }
        </tds-side-menu-dropdown-list>
      </tds-side-menu-dropdown>
    }

    <!-- language toggle for mobile -->
    <tds-side-menu-item slot="sticky-end" style="background-color: white;">
      <button (click)="toggleLanguage()" class="language-toggle-btn">
        <tds-icon name="language" size="20"></tds-icon>
        {{ currentLanguage() === 'en' ? ('sideNav.switchToChinese' | translate) : ('sideNav.switchToEnglish' | translate) }}
      </button>
    </tds-side-menu-item>

    <!-- fullscreen button for mobile -->
    <tds-side-menu-item slot="sticky-end" style="background-color: white;">
      <button (click)="toggleFullscreen()" class="fullscreen-btn-mobile">
        <tds-icon name="expand" size="20"></tds-icon>
        {{ 'header.fullscreen' | translate }}
      </button>
    </tds-side-menu-item>
  }

  <tds-side-menu-collapse-button #collapseButton slot="sticky-end" (tdsCollapse)="tdsCollapseEvent($event)"></tds-side-menu-collapse-button>
</tds-side-menu>